<script>
import AccountAPI from './../../api/account.js'

import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'

export default {
  name: 'ForgotPassword',
  components: {
    Footer,
    HeaderFive
  },
  watch: {
    show_error (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value == true) {
        setTimeout(() => {
          this.show_error = false
          this.error_message = ''
        }, 5000)
      }
    }
  },
  data () {
    return {
      loaded:false,
      allow_reset: false,
      show_error: false,
      error_message: '',
      new_password: '',
      show_new_password: false,
      confirm_password: '',
      show_confirm_password: false,
      reset_password_id: '',
      reset_password_token: '',
      submitting: false,
      password_changed: false
    }
  },
  created()
  {
    try {
      var resethash =  this.$route.params.resethash;
      if(resethash  == '')
      {
          this.allow_reset = false;
          this.loaded = true;
      }
      else
      {
        var verify_resethash_request = AccountAPI.verifyResetHash(resethash);
        verify_resethash_request.then((response)=>{
            if(response.status == 'success')
            {
              var readhash_request = AccountAPI.readHash(resethash);
              readhash_request.then((readhash_response)=>{
                this.allow_reset = true;
                this.loaded = true;
                this.reset_password_token = readhash_response.reset_password_token;
                this.reset_password_id = readhash_response.reset_password_id;
              });
            }
            else
            {
                this.loaded = true;
                this.allow_reset = false;
            }
        });


      }
    } catch(error) {
        this.allow_reset = false;
        this.loaded = true;
    }
  },
  methods: {
    validateChangePassword () {
      var error = {
        message: '',
        has_error: 0
      }
      
      if (this.new_password == '') {
        error.message = 'Please enter your new password'
        error.has_error = 1
        return error
      } else if (this.confirm_password == '') {
        error.message = 'Please confirm your new password'
        error.has_error = 1
        return error
      }  else if (this.confirm_password != this.new_password) {
        error.message = "Password doen't match. Please re-enter your password"
        error.has_error = 1
        return error
      } 
      return error
    },
    changePassword () {
      this.show_error = false
      this.error_message = ''

      var validation = this.validateChangePassword()
      if (validation.has_error) {
        this.show_error = true
        this.error_message = validation.message
        this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      } else {
        try {
          this.submitting = true
          var change_password_request = AccountAPI.changePassword(
            this.new_password,
            this.confirm_password,
            this.reset_password_id,
            this.reset_password_token
          )
          change_password_request.then((response) => {
            if ((response.status).toLowerCase() == 'success.') {
              this.password_changed = true
              this.submitting = false
            }
            else
            {
                for (const field in response.errors) {
                  response.errors[field].forEach((error,error_index)=>{
                    this.error_message = error;
                  });
                }
                this.submitting = false;
                this.show_error = true;
            }
          })
        } catch (error) {
          this.submitting = false
          this.show_error = true
          this.error_message = error
          this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
        }
      }
    },
  }
}
</script>

<template>
  <div class="page register-page">
    <HeaderFive />

      <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                           
                            <h1 class="section-title white-color">Account</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Forgot Password</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="anchor" ref="title" ></div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- LOGIN AREA START (Register) -->
    <div class="ltn__login-area pb-110" v-if="loaded && allow_reset" >
        <div class="container" v-if="!password_changed">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area text-center">
                        <h1  class="section-title">Create new password</h1>
                        <p>Your new password must be different than the previous one</p>
                    </div>
                     <h5 v-if="show_error">{{ error_message }}</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 offset-lg-3">
                    <div class="account-login-inner">
                        <div class="ltn__form-box contact-form-box">

                            <div class="input-item input-item-password mb-4">
                                <input :type="(show_new_password ? 'text' : 'password')" v-model="new_password" name="newpass" placeholder="New Password">
                                <i class="fas" :class="{ 'fa-eye': !show_new_password, 'fa-eye-slash': show_new_password }" @click="show_new_password = !show_new_password"></i>
                            </div>

                             <div class="input-item input-item-password mb-4">
                                <input :type="(show_confirm_password ? 'text' : 'password')" v-model="confirm_password" name="conf_pass" placeholder="Confirm Password">
                                <i class="fas" :class="{ 'fa-eye': !show_confirm_password, 'fa-eye-slash': show_confirm_password }" @click="show_confirm_password = !show_confirm_password"></i>
                            </div>
                            <div class="btn-wrapper">
                                <button @click="changePassword" :disabled="submitting" class="theme-btn-1 btn reverse-color btn-block" type="submit">{{ submitting ? 'PROCESSING' : 'SUBMIT' }}</button>
                            </div>
                        </div>
                        <div class="by-agree text-center">
                             <div class="go-to-btn mt-50">
                                <router-link to="/login">ALREADY HAVE AN ACCOUNT ? LOGIN HERE</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-if="password_changed">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area text-center">
                        <h1 ref="title" class="section-title">Your password has been reset.</h1>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 offset-lg-3">
                    <div class="account-login-inner">
                        <div class="by-agree text-center">
                            <div class="go-to-btn mt-50">
                                <router-link to="/login">ALREADY HAVE AN ACCOUNT ? LOGIN HERE</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- LOGIN AREA END -->

    <!-- LOGIN AREA START (Register) -->
    <div class="ltn__login-area pb-110" v-if="loaded && !allow_reset" >
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area text-center">
                        <h1  class="section-title">Link has expired</h1>
                      
                    </div>
                     
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 offset-lg-3">
                    <div class="account-login-inner">
                        <div class="by-agree text-center">
                             <div class="go-to-btn mt-50">
                                <router-link to="/login">ALREADY HAVE AN ACCOUNT ? LOGIN HERE</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- LOGIN AREA END -->

    <Footer />
  </div>
</template>
<style>
.ltn__login-area h5 {
    background-color: var(--section-bg-1);
    padding: 20px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/PasswordReset.vue